import { provide } from "@lit/context";
import type { ExportFormat } from "@pentacode/core";
import { activeIcon } from "@pentacode/ui/components";
import { html, LitElement, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { enabledFeatures, loadEnabledFeatures, type EnabledFeatures } from "../../../contexts/features-context";
import { menuItemState, type RouteAccess, type RouteNode } from "../../../lib/route-tree";
import { StateMixin } from "../../../mixins/state";
import { shared } from "../../../styles";
import { exportFormat, exportsPages, exportsRoute, type ExportsPage } from "../../app-routes";
import { routeAccess } from "../../route-access";

@customElement("ptc-exports-menu")
export class ExportsMenu extends StateMixin(LitElement) {
    @provide({ context: enabledFeatures })
    @state()
    private _features: EnabledFeatures = loadEnabledFeatures();

    @property({ type: String })
    page: ExportFormat;

    go(page: ExportFormat) {
        this.dispatchEvent(
            new CustomEvent<ExportFormat>("navigate", {
                detail: page,
            })
        );
    }

    static styles = [shared];

    private _renderItem(page: ExportsPage, section: RouteNode["menuSection"], access: RouteAccess) {
        const route = exportsRoute(page);
        const format = exportFormat(page);
        const active = this.page === format;
        return html`
            ${route.menuSection && route.menuSection !== section
                ? html`<div class="subtle margined">
                      ${route.menuSection.icon
                          ? html`<ptc-ui-icon name=${route.menuSection.icon}></ptc-ui-icon>`
                          : nothing}
                      ${route.menuSection.label}
                  </div>`
                : nothing}
            <button
                ?active=${active}
                @click=${() => this.go(format)}
                ?disabled=${menuItemState(route, access) === "disabled"}
            >
                <div class="horizontal center-aligning layout">
                    <div class="stretch">${route.label}</div>
                    ${route.icon
                        ? html`<ptc-ui-icon name=${activeIcon(route.icon, active)} class="subtle"></ptc-ui-icon>`
                        : nothing}
                </div>
            </button>
        `;
    }

    render() {
        const access = routeAccess();
        const visible = exportsPages.filter((page) => menuItemState(exportsRoute(page), access) !== "hidden");
        return html`
            <div class="vertical tabs">
                ${visible.map((page, i) =>
                    this._renderItem(page, i ? exportsRoute(visible[i - 1]).menuSection : undefined, access)
                )}
            </div>
        `;
    }
}
